import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Jul 18 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { jsonConversions, InternalProductPricesDTOConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import { GenericTransportLayer } from '../GenericTransportLayer';
export var InternalProductPricesLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(InternalProductPricesLayer, _GenericTransportLaye);

  function InternalProductPricesLayer() {
    _classCallCheck(this, InternalProductPricesLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(InternalProductPricesLayer).call(this, CONSTANTS.API.ENDPOINTS.CLEANING));
  }

  _createClass(InternalProductPricesLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "getInCategory",
    value: function getInCategory(categoryId) {
      var _this = this;

      var internalProductPricesPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.INTERNAL_PRODUCT_PRICES)).post({
        categoryId: categoryId
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return internalProductPricesPromise;
    }
  }]);

  return InternalProductPricesLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", InternalProductPricesDTOConverter)], InternalProductPricesLayer.prototype, "converter", void 0);